import { interviewDTO } from "./interview.dto";
import { Interview } from "../interview.entity";
import { Injectable } from "@nestjs/common";
import { Entity } from "typeorm";

@Injectable()
export class interviewAdapter{

    public convertDtoToEntity(dto: interviewDTO, isUpdate: boolean = false): Interview{
        const entity = new Interview();
        entity.interviewId = dto.interviewId;
        entity.interviewDate = dto.interviewDate;
        entity.interviewType = dto.interviewType;
        entity.jobDescription = dto.jobDescription;
        entity.interviewer = dto.interviewer;
        entity.interviewerMobileNo = dto.interviewerMobileNo;
        entity.candidateName = dto.candidateName;
        entity.plant = dto.plant;
        entity.notificationId=dto.notificationId;
        entity.status = dto.status;
        entity.willing = dto.willing;
        entity.refereedBy = dto.refereedBy;       
        entity.remarks = dto.remarks;
        if(isUpdate){
            entity.updatedUser = dto.updatedUser;
            entity.interviewId = dto.interviewId;
        }else {
            entity.isActive = true;
            entity.createdUser = dto.createdUser;
        }
        return entity;
    }

    public convertEntityToDto(entity: Interview): interviewDTO{
        const Dto = new interviewDTO;
        Dto.interviewId = entity.interviewId;
        Dto.interviewDate = entity.interviewDate;
        Dto.interviewType = entity.interviewType;
        Dto.jobDescription = entity.jobDescription;
        Dto.interviewer = entity.interviewer;
        Dto.interviewerMobileNo = entity.interviewerMobileNo;
        Dto.candidateName = entity.candidateName;
        Dto.plant = entity.plant;
        Dto.notificationId=entity.notificationId;
        Dto.status = entity.status;
        Dto.willing = entity.willing;
        Dto.refereedBy = entity.refereedBy;       
        Dto.remarks = entity.remarks;
        Dto.isActive = entity.isActive;
        Dto.createdAt = entity.createdAt;
        Dto.createdUser = entity.createdUser;
        Dto.updatedUser = entity.updatedUser;
        Dto.updatedAt = entity.updatedAt;
        Dto.versionFlag = entity.versionFlag;
        return Dto;
    }
}